<template>
  <div>
    <breadcrumbs :back="[{text:'Other equipment',to:{name:'EquipmentOther'}}]" home="Equipment types"/>

    <purtrak-table name="equipmenttypes" objectType="types" :defaultColumns="defaultColumns" :headers="headers" ref="table"
                   listEndPoint="equipmentTypes2"
                   fields="id,name"
                   :listFilters="[]"
                   @dblclick="type => {equipmentType=type;addMode=true}"
                   title="Equipment types"
                   :print-info="{pageSize:'portrait', subTitle:[]}"
                   download-endpoint="equipmentTypesExportCSV">
      <template v-slot:menu v-if="!readOnly">
        <v-list-item @click="equipmentType=null;addMode=true"><v-list-item-title>Create equipment type</v-list-item-title></v-list-item>
      </template>
      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small @click="equipmentType=null;addMode=true"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.action="{item}" v-if="!readOnly">
        <v-btn small icon @click.stop="deleteType(item)"><v-icon small>mdi-delete</v-icon></v-btn>
      </template>
    </purtrak-table>

    <equipment-types-quick-create v-model="addMode" :editType="equipmentType" @create="$refs.table.buildList()"/>
    <delete-object v-model="showDelete" :name="deleteTypeObject.name" @delete="performDeleteType"/>
  </div>
</template>

<script>
import EquipmentTypesQuickCreate from '@/views/equipment/other/EquipmentTypesQuickCreate'

export default {
  name: 'EquipmentTypes',
  components: {EquipmentTypesQuickCreate},
  data() {
    return {
      equipmentType: null,
      deleteTypeObject: {},
      addMode: false,
      showDelete: false,
      defaultColumns: [{ value: 'name', visible:true}],
      headers: [{ text: 'NAME', value: 'name', filterable:true,sortable:true},
                { text: '' , value:'action', width:'5%', filterable:false,sortable:false,sortable:false,align:'center'}]
    }
  },
  computed: {
    readOnly() {
      return !this.$store.getters.company.permissions.includes('config.write');
    }
  },
  methods: {
    deleteType(equipmentType) {
      this.deleteTypeObject = equipmentType;
      this.showDelete = true;
    },
    async performDeleteType() {
      this.loading = true;
      const results = await this.$apiCall(`mutation EquipmentTypes($id: ID!) {
                                             objectDelete(id:$id)
                                           }`,
                                          {id:this.deleteTypeObject.id});
      this.loading = false;
      if (!results.error) {
        this.$refs.table.buildList();
        this.showDelete = false;
      }
    },
  }
}
</script>